/* eslint-disable no-nested-ternary */
import React from "react";
import PropTypes from "prop-types";
import PriceFormat from "../../../components/PriceFormat";

export const NormalPricingComponent = ({ discountPrice, price }) => {
  return (
    <>
      {discountPrice && discountPrice <= price ? (
        <>
          <span className="productPrice__salePriceText">Sale Price:</span>
          <div className="productPrice__discounted">
            <p className="productPrice__discounted--sale">
              <PriceFormat id="priceFormat" value={discountPrice} />
            </p>
            <p className="productPrice__discounted--original">
              <PriceFormat id="priceFormat" value={price} />
            </p>
          </div>
        </>
      ) : price === 0 ? (
        <div className="productPrice--free">Free</div>
      ) : (
        <div className="productPrice--regular">
          <PriceFormat id="priceFormat" value={price} />
        </div>
      )}
    </>
  );
};

NormalPricingComponent.propTypes = {
  price: PropTypes.number,
  discountPrice: PropTypes.number
};

NormalPricingComponent.defaultProps = {
  price: null,
  discountPrice: null
};

export const EnterprisePricingComponent = ({ discountPrice, price }) => {
  return discountPrice && discountPrice <= price ? (
    <>
      <p className="starting-pricing">Pricing starting at</p>
      <div className="enterprisePricing__price--regular">
        Regular Price:&nbsp;
        <span className="regular-price-strikethrough">
          <PriceFormat id="priceFormat" value={price} />
        </span>
      </div>
      <div className="enterprisePricing__price--sale">
        <span>Sale Price</span>
        <p>
          <PriceFormat id="priceFormat" value={discountPrice} />
        </p>
        <p className="per-license">per license</p>
      </div>
    </>
  ) : (
    <div className="enterprisePricing">
      <p className="enterprisePricing__starting">Pricing starting at:</p>
      <p className="enterprisePricing__price">
        <PriceFormat id="priceFormat" value={price} />
      </p>
      <p className="enterprisePricing__perLicense">per license</p>
    </div>
  );
};

EnterprisePricingComponent.propTypes = {
  discountPrice: PropTypes.number,
  price: PropTypes.number
};

EnterprisePricingComponent.defaultProps = {
  discountPrice: null,
  price: null
};
